import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';
import axios from 'axios';
import './not_fully_finished_section.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClose } from '@fortawesome/pro-solid-svg-icons';

const NotFullyFinishedSection = ({ lastFollowUpSentAt: initialLastFollowUpSentAt, profileFollowUpPath }) => {
  const [lastFollowUpSentAt, setLastFollowUpSentAt] = useState(initialLastFollowUpSentAt);
  const [sending, setSending] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    setSending(true);
    axios.post(profileFollowUpPath)
      .then((response) => {
        setSending(false);
        setLastFollowUpSentAt(response.data.lastFollowUpSentAt);
        setShowAlert(true);
        setSent(true);
      })
      .catch((error) => {
        /* eslint-disable no-console */
        console.log(error);
        setSending(false);
      });
  };

  useEffect(() => {
    if (!showAlert) return;

    const timer = setTimeout(() => setShowAlert(false), 5000);

    return () => clearTimeout(timer);
  }, [showAlert]);

  return <React.Fragment>
    <h4 className="mt-4">Would you like to send a follow up to have the lead finish their profile?</h4>

    <div className="d-flex">
      {!sent && <Button className="mr-3" disabled={sending} onClick={handleSend}>
        {sending ? 'Sending...' : 'Send follow up'}
      </Button>}

      {showAlert && <div className="snackbar-message d-flex justify-content-around">
        <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>
        <span>Follow up was sent</span>
        <FontAwesomeIcon icon={faClose} onClick={() => setShowAlert(false)}></FontAwesomeIcon>
      </div>}

      {lastFollowUpSentAt &&
        <p className="my-3 text-muted">Last sent on {moment(lastFollowUpSentAt).format('MM/DD/YY [at] hh:mm a')}</p>}
    </div>
  </React.Fragment>;
};

NotFullyFinishedSection.propTypes = {
  lastFollowUpSentAt: PropTypes.string,
  profileFollowUpPath: PropTypes.string.isRequired
};

export default NotFullyFinishedSection;
